import GATSBY_COMPILED_MDX from "/Users/bl711/Code/eto-platform/eto-platform/src/content/blog/introducing_country_activity_tracker.mdx";
import * as React from "react";
import {graphql} from "gatsby";
import {MDXProvider} from "@mdx-js/react";
import {AppWrapper, ExternalLink} from "@eto/eto-ui-components";
import Blog from "../components/blog";
import ToolDocumentation from "../components/tool_documentation";
import DatasetDocumentation from "../components/dataset_documentation";
import DataWrapperChart from "@components/DataWrapperChart";
import OpenGraphMeta from "../components/OpenGraphMeta";
import TableWrapper from "@components/TableWrapper";
const Post = ({data, children}) => {
  const components = {
    DataWrapperChart,
    ExternalLink,
    TableWrapper
  };
  return React.createElement(MDXProvider, {
    components: components
  }, React.createElement(AppWrapper, {
    fromPlatform: true
  }, data.mdx.fields.slug.match(/blog\//) ? React.createElement(Blog, {
    authors: data.mdx.frontmatter.authors,
    body: children,
    date: data.mdx.frontmatter.date,
    dek: data.mdx.frontmatter.dek,
    image: data.mdx.frontmatter.image?.publicURL,
    imageAltText: data.mdx.frontmatter.imageAltText,
    substackUrl: data.mdx.frontmatter?.substackUrl,
    tags: data.mdx.frontmatter.tags,
    title: data.mdx.frontmatter.title
  }) : data.mdx.fields.slug.match(/tool-docs\//) ? React.createElement(ToolDocumentation, {
    title: data.mdx.frontmatter.title,
    date: data.mdx.frontmatter.date,
    authors: data.mdx.frontmatter.authors,
    body: children,
    tags: data.mdx.frontmatter.tags,
    toc: data.mdx.tableOfContents
  }) : data.mdx.fields.slug.match(/dataset-docs\//) && React.createElement(DatasetDocumentation, {
    title: data.mdx.frontmatter.title,
    date: data.mdx.frontmatter.date,
    authors: data.mdx.frontmatter.authors,
    body: children,
    tags: data.mdx.frontmatter.tags,
    toc: data.mdx.tableOfContents
  })));
};
export const query = graphql`
  query ($id: String) {
    mdx(id: {eq: $id}) {
      frontmatter {
        authors
        date(formatString: "MMMM D, YYYY")
        dek
        image {
          publicURL
        }
        imageAltText
        substackUrl
        tags
        title
      }
      body
      tableOfContents
      fields {
        slug
      }
    }
  }
`;
Post
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Post, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export function Head({pageContext}) {
  return React.createElement(OpenGraphMeta, {
    customImage: pageContext.fields__slug.match(/blog\//),
    description: pageContext.frontmatter.dek,
    slug: pageContext.fields__slug,
    subtitle: pageContext.frontmatter.title
  });
}
